import { render, staticRenderFns } from "./TxnStatusPanel.vue?vue&type=template&id=262ac0c7&"
import script from "./TxnStatusPanel.vue?vue&type=script&lang=ts&"
export * from "./TxnStatusPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports